// extracted by mini-css-extract-plugin
module.exports = {"error":"Layout_error__33Yu-","mainLayout":"Layout_mainLayout__1sez5","mainBody":"Layout_mainBody__1Gfss","mainBlock":"Layout_mainBlock__uKDcb"};